import Button from "@widgets/button/button";
import React from "react";
export default function Social({ buttons }) {
    return (React.createElement("div", { className: "ltg-social" }, buttons && buttons.map((btn) => {
        return React.createElement(Button, { tooltip: btn.title, icon: btn.icon, rounded: "yes", title: null, color: btn.color, url: btn.url, key: btn._id });
    })));
}
